import React, {
  useEffect,
  useState,
} from "react";

import {
  useTranslation,
} from "react-i18next";

import {
  useSelector,
  useDispatch,
} from "react-redux";

import {
  motion,
  AnimatePresence,
} from "framer-motion";

import {
  Loader,
  MealCategoryCard,
} from "../components/utils";

import {
  Fotter,
  Header,
} from "../components/layout";

import {
  getAllCategorys,
} from "../redux/actions/category";

import {
  MealsCategoriesImage,
} from "../assets";

import {
  useStateContext,
} from "../context/ContextProvider";

import {
  FiArrowDown,
  FiGrid,
} from "react-icons/fi";

import {
  BiRestaurant,
} from "react-icons/bi";


function MealsCategories() {
  const {
    t,
  } = useTranslation();

  const dispatch =
    useDispatch();

  const {
    currentDir,
  } = useStateContext();


  /* =====================================
      DIRECTION
  ====================================== */

  const isRTL =
    currentDir === "rtl";


  /* =====================================
      REDUX - CATEGORIES
  ====================================== */

  const {
    isLoading,
    AllCategorys,
  } = useSelector(
    (state) =>
      state.Categorys
  );


  /* =====================================
      GLOBAL MOBILE VIEW

      one = عمود واحد
      two = عمودان

      الافتراضي = عمودان
  ====================================== */

  const mobileMealColumns =
    useSelector(
      (state) =>
        state.Layout
          ?.mobileMealColumns ||
        "two"
    );


  /* =====================================
      MOBILE DETECTION
  ====================================== */

  const [
    isMobile,
    setIsMobile,
  ] = useState(() => {
    if (
      typeof window ===
      "undefined"
    ) {
      return false;
    }

    return (
      window.innerWidth <
      768
    );
  });


  useEffect(() => {
    const handleResize =
      () => {
        setIsMobile(
          window.innerWidth <
            768
        );
      };


    window.addEventListener(
      "resize",
      handleResize
    );


    handleResize();


    return () => {
      window.removeEventListener(
        "resize",
        handleResize
      );
    };
  }, []);


  /* =====================================
      LOAD CATEGORIES
  ====================================== */

  useEffect(() => {
    dispatch(
      getAllCategorys(
        1,
        100
      )
    );
  }, [
    dispatch,
  ]);


  /* =====================================
      SAFE DATA
  ====================================== */

  const categories =
    Array.isArray(
      AllCategorys
    )
      ? AllCategorys
      : [];


  /* =====================================
      CARD MODE

      compact فقط عندما:
      - الشاشة هاتف
      - المستخدم اختار عمودين

      الكمبيوتر دائماً
      يستخدم الشكل الكامل.
  ====================================== */

  const compactCard =
    isMobile &&
    mobileMealColumns ===
      "two";


  return (
    <>
      {/* =====================================
          HEADER
      ====================================== */}

      <Header
        active={4}
        DropActive={4}
      />


      <main
        className="
          min-h-screen

          bg-back-primery
          dark:bg-back-darkprimery
        "
      >

        {/* =================================
            HERO
        ================================= */}

        <section
          className="
            relative

            overflow-hidden

            h-[500px]
            md:h-[570px]
            lg:h-[620px]

            bg-color-2
          "
        >

          {/* =================================
              BACKGROUND IMAGE
          ================================= */}

          <motion.img
            initial={{
              opacity: 0,
              scale: 1.08,
            }}

            animate={{
              opacity: 1,
              scale: 1,
            }}

            transition={{
              duration: 1.1,
            }}

            src={
              MealsCategoriesImage
            }

            alt={t(
              "Yaman menu categories"
            )}

            className="
              absolute
              inset-0

              w-full
              h-full

              object-cover
            "
          />


          {/* =================================
              LIGHT GLOBAL OVERLAY
          ================================= */}

          <div
            className="
              absolute
              inset-0

              bg-black/10
            "
          />


          {/* =================================
              DIRECTIONAL BRAND OVERLAY
          ================================= */}

          <div
            className={`
              absolute
              inset-0

              ${
                isRTL
                  ? `
                    bg-gradient-to-l

                    from-color-2/90
                    via-color-2/55
                    to-transparent
                  `
                  : `
                    bg-gradient-to-r

                    from-color-2/90
                    via-color-2/55
                    to-transparent
                  `
              }
            `}
          />


          {/* =================================
              BOTTOM CINEMATIC OVERLAY
          ================================= */}

          <div
            className="
              absolute
              inset-0

              bg-gradient-to-t

              from-color-2/80
              via-transparent
              to-black/10
            "
          />


          {/* =================================
              GOLD GLOW
          ================================= */}

          <div
            className={`
              absolute

              top-14

              w-[320px]
              h-[320px]

              rounded-full

              bg-color-1/20

              blur-[130px]

              pointer-events-none

              ${
                isRTL
                  ? "-right-36"
                  : "-left-36"
              }
            `}
          />


          {/* =================================
              HERO CONTENT
          ================================= */}

          <div
            className="
              relative
              z-10

              container

              h-full

              flex
              items-end

              pb-14
              md:pb-20
            "
          >

            <motion.div
              initial={{
                opacity: 0,
                y: 45,
              }}

              animate={{
                opacity: 1,
                y: 0,
              }}

              transition={{
                duration: 0.75,
                delay: 0.1,
              }}

              className="
                max-w-[800px]
              "
            >

              {/* =============================
                  EYEBROW
              ============================== */}

              <div
                className="
                  flex

                  items-center

                  gap-3

                  mb-6
                "
              >

                <span
                  className="
                    block

                    w-12
                    md:w-16

                    h-[2px]

                    bg-color-1
                  "
                />


                <BiRestaurant
                  className="
                    text-color-1

                    text-lg
                  "
                />


                <span
                  className="
                    font-kufi

                    text-xs
                    md:text-sm

                    text-color-1
                  "
                >
                  {t(
                    "Yaman food experience"
                  )}
                </span>

              </div>


              {/* =============================
                  TITLE
              ============================== */}

              <h1
                className="
                  font-kufi
                  font-bold

                  text-white

                  text-[2.6rem]
                  leading-[1.45]

                  md:text-6xl

                  lg:text-[4.3rem]
                  lg:leading-[1.3]

                  mb-6
                "
              >
                {t(
                  "discover Yaman menu categories"
                )}
              </h1>


              {/* =============================
                  DESCRIPTION
              ============================== */}

              <p
                className="
                  max-w-2xl

                  font-kufi

                  text-sm
                  md:text-lg

                  text-white/75

                  leading-8
                  md:leading-9
                "
              >
                {t(
                  "Yaman menu categories description"
                )}
              </p>


              {/* =============================
                  SCROLL INDICATOR
              ============================== */}

              <motion.div
                initial={{
                  opacity: 0,
                  y: 15,
                }}

                animate={{
                  opacity: 1,
                  y: 0,
                }}

                transition={{
                  duration: 0.6,
                  delay: 0.25,
                }}

                className="
                  flex

                  items-center

                  gap-3

                  mt-8
                "
              >

                <div
                  className="
                    flex

                    w-9
                    h-9

                    items-center
                    justify-center

                    rounded-full

                    border
                    border-white/20

                    text-color-1
                  "
                >
                  <FiArrowDown />
                </div>


                <span
                  className="
                    font-kufi

                    text-xs

                    text-white/50
                  "
                >
                  {t(
                    "choose a category to explore"
                  )}
                </span>

              </motion.div>

            </motion.div>

          </div>


          {/* =================================
              BOTTOM ACCENT
          ================================= */}

          <div
            className="
              absolute

              bottom-0
              start-0

              w-32
              md:w-52

              h-[3px]

              bg-color-1
            "
          />

        </section>


        {/* =================================
            CATEGORIES CONTENT
        ================================= */}

        <section
          id="categories-section"

          className="
            relative

            overflow-hidden

            bg-back-secondary
            dark:bg-back-darkprimery

            py-14
            md:py-20
            lg:py-24
          "
        >

          {/* =================================
              BACKGROUND GLOW
          ================================= */}

          <div
            className="
              absolute

              -top-44
              -end-44

              w-[420px]
              h-[420px]

              rounded-full

              bg-color-1/[0.08]

              blur-[120px]

              pointer-events-none
            "
          />


          {/* =================================
              BACKGROUND CIRCLE
          ================================= */}

          <div
            className="
              absolute

              -bottom-40
              -start-40

              w-[380px]
              h-[380px]

              rounded-full

              border
              border-color-1/10

              pointer-events-none
            "
          />


          <div
            className="
              container

              relative
              z-10
            "
          >

            {/* =================================
                SECTION HEADER
            ================================= */}

            <motion.div
              initial={{
                opacity: 0,
                y: 25,
              }}

              whileInView={{
                opacity: 1,
                y: 0,
              }}

              viewport={{
                once: true,
                amount: 0.2,
              }}

              transition={{
                duration: 0.65,
              }}

              className="
                flex
                flex-col

                md:flex-row
                md:items-end
                md:justify-between

                gap-6
                md:gap-7

                pb-7
                mb-8
                md:mb-10

                border-b
                border-color-2/10
                dark:border-white/10
              "
            >

              {/* =============================
                  HEADING
              ============================== */}

              <div>

                <div
                  className="
                    flex

                    items-center

                    gap-3

                    mb-3
                  "
                >

                  <FiGrid
                    className="
                      text-color-1
                    "
                  />


                  <span
                    className="
                      font-kufi

                      text-[10px]
                      sm:text-xs

                      text-color-1
                    "
                  >
                    {t(
                      "Yaman menu categories"
                    )}
                  </span>

                </div>


                <h2
                  className="
                    font-kufi
                    font-semibold

                    text-xl
                    sm:text-2xl
                    md:text-3xl

                    text-tcolor-4
                    dark:text-tcolor-1
                  "
                >
                  {t(
                    "choose what you are craving"
                  )}
                </h2>

              </div>


              {/* =============================
                  CATEGORY COUNT
              ============================== */}

              <div
                className="
                  flex

                  w-fit

                  items-center

                  gap-3

                  rounded-full

                  border
                  border-color-2/10
                  dark:border-white/10

                  bg-back-primery
                  dark:bg-back-darksecondary

                  px-4
                  py-3
                "
              >

                <div
                  className="
                    flex

                    w-9
                    h-9

                    shrink-0

                    items-center
                    justify-center

                    rounded-full

                    bg-color-1/10

                    text-color-1
                  "
                >
                  <BiRestaurant />
                </div>


                <div>

                  <span
                    className="
                      block

                      font-kufi

                      text-[9px]
                      md:text-[10px]

                      text-n-5
                      dark:text-tcolor-3
                    "
                  >
                    {t(
                      "available categories"
                    )}
                  </span>


                  <span
                    className="
                      font-kufi
                      font-semibold

                      text-xs
                      md:text-sm

                      text-tcolor-4
                      dark:text-white
                    "
                  >
                    {
                      categories.length
                    }{" "}
                    {t(
                      "categories"
                    )}
                  </span>

                </div>

              </div>

            </motion.div>


            {/* =================================
                LOADING
            ================================= */}

            {isLoading &&
            categories.length ===
              0 ? (

              <div
                className="
                  min-h-[400px]

                  flex
                  items-center
                  justify-center
                "
              >
                <Loader />
              </div>

            ) : (

              <>

                {/* =================================
                    CATEGORIES GRID
                ================================= */}

                {categories.length >
                0 ? (

                  <AnimatePresence
                    mode="wait"
                  >

                    <motion.div
                      key={
                        mobileMealColumns
                      }

                      initial={{
                        opacity: 0,
                      }}

                      animate={{
                        opacity: 1,
                      }}

                      exit={{
                        opacity: 0,
                      }}

                      transition={{
                        duration: 0.3,
                      }}

                      className={`
                        grid

                        ${
                          mobileMealColumns ===
                          "two"
                            ? `
                              grid-cols-2
                              gap-3
                            `
                            : `
                              grid-cols-1
                              gap-6
                            `
                        }

                        md:grid-cols-2
                        md:gap-7

                        xl:grid-cols-3
                        xl:gap-8
                      `}
                    >

                      {categories.map(
                        (
                          category,
                          index
                        ) => (

                          <motion.div
                            key={
                              category?._id ||
                              index
                            }

                            initial={{
                              opacity: 0,
                              y: 25,
                            }}

                            animate={{
                              opacity: 1,
                              y: 0,
                            }}

                            transition={{
                              duration: 0.45,

                              delay:
                                Math.min(
                                  index *
                                    0.04,
                                  0.25
                                ),
                            }}

                            className="
                              min-w-0
                              h-full
                            "
                          >

                            <MealCategoryCard
                              category={
                                category
                              }

                              index={
                                index
                              }

                              compact={
                                compactCard
                              }
                            />

                          </motion.div>

                        )
                      )}

                    </motion.div>

                  </AnimatePresence>

                ) : (

                  /* =================================
                      EMPTY STATE
                  ================================= */

                  <motion.div
                    initial={{
                      opacity: 0,
                      y: 20,
                    }}

                    animate={{
                      opacity: 1,
                      y: 0,
                    }}

                    transition={{
                      duration: 0.5,
                    }}

                    className="
                      rounded-[2rem]

                      border
                      border-color-1/15

                      bg-back-primery
                      dark:bg-back-darksecondary

                      py-14
                      md:py-16

                      px-6

                      text-center
                    "
                  >

                    <div
                      className="
                        flex

                        w-16
                        h-16

                        mx-auto
                        mb-5

                        items-center
                        justify-center

                        rounded-full

                        bg-color-1/10

                        text-color-1
                      "
                    >
                      <FiGrid
                        className="
                          text-2xl
                        "
                      />
                    </div>


                    <h3
                      className="
                        font-kufi
                        font-semibold

                        text-lg
                        md:text-2xl

                        text-tcolor-4
                        dark:text-tcolor-1

                        mb-3
                      "
                    >
                      {t(
                        "no categories available"
                      )}
                    </h3>


                    <p
                      className="
                        max-w-lg

                        mx-auto

                        font-kufi

                        text-xs
                        md:text-sm

                        text-n-6
                        dark:text-tcolor-2

                        leading-7
                      "
                    >
                      {t(
                        "Yaman categories will appear here"
                      )}
                    </p>

                  </motion.div>

                )}

              </>

            )}

          </div>

        </section>

      </main>


      {/* =====================================
          FOOTER
      ====================================== */}

      <Fotter />
    </>
  );
}


export default MealsCategories;